const ActionTypes = {
  GET_YEAR_LIST: '[Years] Get Year List',
  GET_YEAR_LIST_SUCCESS: '[Years] Get Year List Success',
  GET_YEAR_LIST_FAIL: '[Years] Get Year List Fail',
}

export class GetYearList {
  static type = ActionTypes.GET_YEAR_LIST;
}

export class GetYearListSuccess {
  static type = ActionTypes.GET_YEAR_LIST_SUCCESS;

  constructor(public payload: {content: number[], warning: string}) {}
}

export class GetYearListFail {
  static type = ActionTypes.GET_YEAR_LIST_FAIL;

  constructor(public payload: { status: number; message: string }) {}
}
